import { getCookie } from '@helper/functions';
import api from './axios';

const baseUrl = import.meta.env.VITE_API_URL;

export const getStatisticsAgent = async (advertiser) => {
  const res = await api.get(`admin/agents/count/${advertiser}`);
  return res.data.data;
};

export const getAgent = async (filter, page = 1, limit = 100) => {
  const res = await api.get(`panel/agents/?page=${page}&limit=${limit}&${filter}`);
  return {
    results: res.data.results,
    data: res.data.data.data,
    totalAgents: res.data.totalAgents,
  };
};

export const getAds = async (page = 1, limit = 5, sort = 'newest') => {
  const res = await api.get(`/panel/ads?page=${page}&limit=${limit}&sort=${sort}`);
  return {
    // results: res.data.results,
    data: res.data,
    // totalAds: res.data.totalAds,
    // totalPages: res.data.totalPages,
  };
};

export const getAdsByAgent = async (id, filter, page = 1, limit = 5) => {
  const res = await api.get(`admin/ads/agent/${id}?page=${page}&limit=${limit}&${filter}`);
  return {
    results: res.data.results,
    data: res.data.data.data,
    totalAds: res.data.totalAds,
    totalPages: res.data.totalPages,
  };
};

export const getOneAgent = async (realState) => {
  const res = await api.get(`users/agent/${realState}`);
  return res.data.data.data;
};

export const getOneAds = async (id) => {
  const res = await api.get(`/panel/ads/${id}`);

  return res.data;
};

// Studio API functions
export const getStudioImages = async (advertisementId) => {
  const res = await api.get(`/studio/images?advertisement_id=${advertisementId}`);
  return res.data;
};

export const saveStudioImages = async (advertisementId, studioData, images = []) => {
  const formData = new FormData();
  formData.append('advertisement_id', advertisementId);
  formData.append('studio_data', JSON.stringify(studioData));

  images.forEach((file) => {
    formData.append('images[]', file);
  });

  const res = await api.post('/studio/images', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
};

export const updateStudioSection = async (action, data) => {
  const res = await api.post('/studio/section', { action, ...data });
  return res.data;
};

export const updateStudioImage = async (action, data) => {
  const res = await api.post('/studio/image', { action, ...data });
  return res.data;
};

export const getUser = async () => {
  const res = await api.get(`/panel/user`);

  return res.data.UserInfo;
};

export const deleteAds = async (idList) => {
  const res = await api.delete(`/panel/ads`, {
    data: { ad_id: idList },
  });
  return res.data.data;
};

export const draftAds = async (isDrafted, idList) => {
  const res = await api.patch(`panel/ads`, { isDrafted, ad_id: idList });
  return res.data.data;
};

export const pinAds = async (isEncrypted, idList) => {
  const res = await api.patch(`panel/ads/locked`, {
    ad_id: idList,
    islocked: isEncrypted,
  });
  return res.data.data;
};

export const toggleAiAds = async (isAi, adId) => {
  const res = await api.patch(`panel/ads/isai`, {
    ad_id: adId,
    isAi: isAi,
  });
  return res.data.data;
};

export const deleteAgent = async (id) => {
  const url = `${baseUrl}/panel/agent/dismiss/${id}`;

  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Network response was not ok: ' + response.statusText);
    }

    const data = await response.json();

    // Assuming the structure of the response
    return data?.data || data;
  } catch (error) {
    return null;
  }
};

export const changeSettings = async (realState, input) => {
  await api.put(`admin/realState/${realState}`, input);
};

export const changeLogoSettings = async (realState, input) => {
  const formData = new FormData();
  formData.append('profile', input);
  await api.put(`admin/realState/images/${realState}`, formData);
};

export const changeProfileAgent = async (profilePicture = '', id) => {
  const formData = new FormData();
  formData.append('profilePicture', profilePicture);
  await api.put(`admin/agents/images/${id}`, formData);
};

export const deleteProfileAgent = async (profilePicture, banner, id) => {
  const data =
    profilePicture && banner
      ? {
          deleteBanner: 'true',
          deleteProfile: 'true',
        }
      : profilePicture && !banner
        ? {
            deleteProfile: 'true',
          }
        : !profilePicture &&
          banner && {
            deleteBanner: 'true',
          };

  await api.put(`admin/agents/deleteImages/${id}`, data);
};

export const signUpAgent = async (data) => {
  return fetch(`${baseUrl}/Register/Agent`, {
    method: 'POST',
    // headers: {
    //   Authorization: `Bearer ${cookieaccess}`,
    //   'Content-Type': 'application/json; charset=utf-8', // Set the content type to JSON
    // },
    credentials: 'include',
    body: data,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data);
};

export const signUpRealestate = async (data) => {
  // const cookieaccess = await getCookie('accessToken');

  return fetch(`${baseUrl}/Register/RealEstate`, {
    method: 'POST',
    // headers: {
    //   Authorization: `Bearer ${cookieaccess}`,
    // },
    credentials: 'include',
    body: data,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data);
};

export const sendOtp = (phoneNumber) => {
  const data = { phoneNumber };

  return fetch(`${baseUrl}/auth`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json', // Set the content type to JSON
    },
    credentials: 'include',
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data);
};

export const checkOtp = (phoneNumber, code) => {
  const data = { phoneNumber, verificationCode: code };

  return fetch(`${baseUrl}/auth`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8', // Set the content type to JSON
    },
    credentials: 'include',
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => data);
};

export const isSubdomainAvailable = (name) => {
  const data = {
    subdomain: name,
  };

  return fetch(`${baseUrl}/panel/Settings/subdomain/check`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;', // Set the content type to JSON
    },
    credentials: 'include',
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => data);
};

export const isUsernameAvailable = (username) => {
  const data = {
    username: username,
  };

  return fetch(`${baseUrl}/public/username/check`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => data);
};

export const getRealState = async () => {
  const res = await api.get(`/panel/RealEstate`);
  return res.data.RealEstateInfo;
};

export const getViews = async () => {
  const res = await api.get(`admin/ads/views`);
  return res.data.data;
};

export const getNewTokens = async () => {
  try {
    const res = await api.post(`auth/refreshToken`, {
      token: getCookie('refreshToken'),
    });
    return res.data.token;
  } catch (error) {
    return null;
  }
};

export const logout = async () => {
  try {
    await api.delete(`/auth/logout`);
  } catch (error) {
    return null;
  }
};

export const accept = async (status, id) => {
  const cookieaccess = await getCookie('accessToken');

  return fetch(`${baseUrl}/panel/agents/invitations/respond`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${cookieaccess}`,
      'Content-Type': 'application/json; charset=utf-8', // Set the content type to JSON
    },
    body: JSON.stringify({
      status: status,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data);
};
